"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedLocales = exports.SupportedLocalesUtility = void 0;
/*
 * Copyright '2021' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
class SupportedLocalesUtility {
    constructor() {
        this.ALL_SUPPORTED_LOCALES = [
            'en_US',
            'es_ES',
            'fr_FR',
            'de_DE',
            'it_IT',
            'ja_JP',
            'ko_KR',
            'pt_PT',
            'ru_RU',
            'zh_CN',
            'zh_TW'
        ];
        this.DEFAULT_LOCALE = 'en_US';
    }
    static getInstance() {
        if (!SupportedLocalesUtility.instance) {
            SupportedLocalesUtility.instance = new SupportedLocalesUtility();
        }
        return SupportedLocalesUtility.instance;
    }
    isLocaleSupported(requestedLocale) {
        if (!requestedLocale) {
            return false;
        }
        requestedLocale = requestedLocale.replace('-', '_');
        requestedLocale = requestedLocale.toLowerCase();
        for (const supportedLocale of this.ALL_SUPPORTED_LOCALES) {
            if (supportedLocale.toLowerCase() === requestedLocale) {
                return true;
            }
        }
        return false;
    }
    getLocaleOrDefaultIfNotSupported(locale) {
        return this.isLocaleSupported(locale) ? this.normalizeLocale(locale) : this.DEFAULT_LOCALE;
    }
    normalizeLocale(locale) {
        if (!locale) {
            return '';
        }
        locale = locale.replace('-', '_');
        if (locale.indexOf('_') < 0) {
            return '';
        }
        const pieces = locale.split('_');
        if (pieces.length !== 2) {
            return '';
        }
        return `${pieces[0].toLowerCase()}_${pieces[1].toUpperCase()}`;
    }
}
exports.SupportedLocalesUtility = SupportedLocalesUtility;
exports.SupportedLocales = SupportedLocalesUtility.getInstance();
//# sourceMappingURL=supported-locales-utility.js.map